import { render, staticRenderFns } from "./prizeTable.vue?vue&type=template&id=35f325e3&"
import script from "./prizeTable.vue?vue&type=script&lang=js&"
export * from "./prizeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports